
import type { MasterDatabaseRecord } from "@/modules/adminPortal/api/masterDatabase.api";

export interface MasterDatabaseDisplayRecord {
  id: string;
  candidateCode: string;
  candidateName: string;
  email: string;
  contact: string;
  location: string;
  entity: string;
  position: string;
  hrName: string;
  source: string;
  experience: string;
  currentSalary: string;
  expectedSalary: string;
  callStatus: string;
  finalStatus: string;
  daysInPipeline: string;
  voiceCallCompleted: boolean;
  isBlacklisted: boolean;
  hod: string;
  reportingManager: string;
  screeningDate: string;
  realEstateExperience: boolean;
  noticePeriod: string;
  hrInterviewStatus: string;
  businessRound1Status: string;
  businessRound2Status: string;
  offerDate: string;
  blacklistedReason: string;
}

const text = (value: unknown): string =>
  value == null ? "" : String(value).trim();

const yes = (value: unknown): boolean =>
  ["yes", "true", "1"].includes(text(value).toLowerCase());

const numberText = (value: unknown): string => {
  const valueText = text(value);
  return valueText || "—";
};

export const mapMasterDatabaseRecord = (
  record: MasterDatabaseRecord,
): MasterDatabaseDisplayRecord => ({
  id: text(record.id),
  candidateCode: text(record.candidateId) || text(record.serialNo) || text(record.id),
  candidateName: text(record.candidateName) || "—",
  email: "",
  contact: text(record.contactNo) || "—",
  location: text(record.location) || "—",
  entity: text(record.entity) || "—",
  position: text(record.position) || "—",
  hrName: text(record.hrName) || "—",
  source: text(record.source) || "—",
  experience: numberText(record.totalExperience),
  currentSalary: numberText(record.currentInhand),
  expectedSalary: numberText(record.expectedInhand),
  callStatus: text(record.callStatus) || "Pending",
  finalStatus: text(record.hrInterviewStatus) || "New",
  daysInPipeline: text(record.ageing) || "—",
  voiceCallCompleted: text(record.callStatus).toLowerCase() === "connected",
  isBlacklisted: yes(record.candidateBlacklisted),
  hod: text(record.hodName) || "—",
  reportingManager: text(record.reportingManager) || "—",
  screeningDate: text(record.screeningDate) || "—",
  realEstateExperience: yes(record.realStateExperience),
  noticePeriod: text(record.noticePeriod) || "—",
  hrInterviewStatus: text(record.hrInterviewStatus) || "Pending",
  businessRound1Status: text(record.interviewLineup) || "Pending",
  businessRound2Status: "Pending",
  offerDate: text(record.business1Date) || "—",
  blacklistedReason: "",
});
